module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mby-wrapper"
  }, [_c('ThreatenedSpeciesMap', {
    attrs: {
      "id": "mby-top"
    }
  }), _vm._v(" "), _c('ElectorateDetails', {
    attrs: {
      "gradesPopupLink": _vm.gradesPopupLink
    }
  }), _vm._v(" "), _c('SpeciesDetails', {
    staticClass: "mby-species-details",
    attrs: {
      "id": "species-details",
      "datalayerName": _vm.datalayerName,
      "programName": _vm.programName,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource,
      "iveCampaignId": _vm.iveCampaignId,
      "messageId": _vm.messageId,
      "cards": _vm.cards,
      "thankYouUrl": _vm.thankYouUrl,
      "privacyPolicyUrl": _vm.privacyPolicyUrl,
      "recovery-grade-status-title": _vm.recoveryGradeStatusTitle,
      "recovery-grade-status-subtitle": _vm.recoveryGradeStatusSubtitle,
      "recovery-grade-status-legend": _vm.recoveryGradeStatusLegend,
      "recovery-grade-status-description": _vm.recoveryGradeStatusDescription,
      "display-progress-numbers-title": _vm.displayProgressNumbersTitle,
      "display-progress-numbers-sigup-message": _vm.displayProgressNumbersSigupMessage,
      "display-progress-numbers-goal-message": _vm.displayProgressNumbersGoalMessage,
      "display-progress-numbers-petition-goal": _vm.displayProgressNumbersPetitionGoal,
      "form-header-title": _vm.formHeaderTitle,
      "form-supporter-details-title": _vm.formSupporterDetailsTitle,
      "form-supporter-details-subtitle": _vm.formSupporterDetailsSubtitle
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mby-disclaimer"
  }, [_vm._v("\n    We acknowledge the First Nations language groups mentioned in the My\n    Backyard tool as the holders of their language and cultural knowledge.\n  ")]), _vm._v(" "), _c('ThreatenedSpeciesModal', {
    attrs: {
      "datalayer-name": _vm.datalayerName,
      "petition-goal": _vm.displayProgressNumbersPetitionGoal,
      "title": _vm.threatenedSpeciesModalTitle,
      "subtitle": _vm.threatenedSpeciesModalSubtitle,
      "description-line1": _vm.threatenedSpeciesModalDescriptionLine1,
      "description-line2": _vm.threatenedSpeciesModalDescriptionLine2
    }
  }), _vm._v(" "), _c('OtherSpeciesPopup')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5e6641e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/ThreatenedSpecies.vue
// module id = 839
// module chunks = 0